import { Col, Modal, Row, Space } from "antd";
import React from "react";
import AtomPrimaryButton from "../button/primary-button";
import AtomSecondaryButton from "../button/secondary-button";
import infoCircle from "../../assets/icon/info-circle.svg";

const WarningModal = ({
  open,
  setOpen,
  onOk,
  onCancel,
  message,
  action,
  loading,
}) => {
  return (
    <Modal
      closable={false}
      centered
      open={open?.visible}
      footer={null}
      width={400}
    >
      <Row className="text-center" gutter={[0, 16]}>
        <Col span={24}>
          <img src={infoCircle} alt="warning" />
        </Col>
        <Col span={24}>
          <b>{message}</b>
        </Col>
        <Col span={24}>
          <Space size="large">
            <AtomPrimaryButton
              danger={action === ", Reject" || action === ", Cancel" || action === ", Remove" || action === ", Delete"}
              loading={loading}
              onClick={() => onOk()}
            >
              Yes{action ?? ""}
            </AtomPrimaryButton>
            <AtomSecondaryButton
              onClick={() => {
                if (onCancel) onCancel();
                setOpen({ visible: false });
              }}
            >
              No, Cancel
            </AtomSecondaryButton>
          </Space>
        </Col>
      </Row>
    </Modal>
  );
};

export default WarningModal;
